export class ManagePositions {
  IsTrader: boolean;
  IsCustomModularity: boolean;
  IsModuleProduct: boolean;
}
